@if (sections.length > 0) {
    <hive-accordion size="smaller-inplace">
        @for (section of sections; track $index) {
            <hive-accordion-tab [heading]="section.name" [itemId]="section.name + '-' + $index" [isOpen]="isLoading">
                <!-- The @if wraps its content in an embedded view, which would no longer
                     match hive's [slot=left] projection selector and fall through to the
                     tab body; ngProjectAs keeps the dot in the header's left slot. -->
                <ng-container ngProjectAs="[slot=left]">
                    @if (statusDotClass(section.status); as dotClass) {
                        <span
                            class="status-dot {{ dotClass }}"
                            role="img"
                            [attr.aria-label]="'Status: ' + section.status"
                        ></span>
                    }
                </ng-container>
                <!-- Hive hides its own (left-side) chevron whenever [slot=left] has
                     content, so the expand affordance is a chevron on the right,
                     rotated via CSS off hive's --expanded class. -->
                <hive-icon-component slot="right" class="section-chevron" [icon]="faChevronDown" size="medium" />
                <div class="collapsible-section-content">
                    <markdown ngPreserveWhitespaces [disableSanitizer]="false" [data]="section.body" />
                </div>
            </hive-accordion-tab>
        }
    </hive-accordion>
}
